<template>
  <HistoryChangeTable
    :endpoint="config.endpoint"
    :base-params="{ [config.referenceParam]: referenceId }"
    :action-options="actionOptions"
    :no-change-text="messages.NO_CHANGE"
    :no-match-text="messages.NO_MATCH"
    :invalid-date-range-text="messages.INVALID_DATE_RANGE"
    :on-error="onError"
    :action-label="actionLabel"
    @show-detail="showDetail"
  >
    <PromotionAccessoryHistoryDetail ref="history-detail" :source="source" />
  </HistoryChangeTable>
</template>

<script>
import {
  ACCESSORY_HISTORY_SOURCE,
  COUPON_HISTORY_ACTION_OPTIONS,
  PROMOTION_ACCESSORY_HISTORY_MESSAGES,
} from '@/utils/constants';
import HistoryChangeTable from '@/view/components/history/HistoryChangeTable.vue';
import { toastHistoryError } from '@/view/components/history/history-error';
import PromotionAccessoryHistoryDetail from '@/view/components/promotion-accessories/PromotionAccessoryHistoryDetail.vue';

export default {
  name: 'PromotionAccessoryHistoryTable',
  components: { HistoryChangeTable, PromotionAccessoryHistoryDetail },
  props: {
    referenceId: { type: [Number, String], required: true },
    source: {
      type: String,
      default: 'PROMOTION',
      validator: (value) => value in ACCESSORY_HISTORY_SOURCE,
    },
  },
  data() {
    return {
      // Không có Xóa: bộ đã xóa không mở lại được
      actionOptions: COUPON_HISTORY_ACTION_OPTIONS,
      messages: PROMOTION_ACCESSORY_HISTORY_MESSAGES,
    };
  },
  computed: {
    config() {
      return ACCESSORY_HISTORY_SOURCE[this.source];
    },
  },
  methods: {
    actionLabel(item) {
      return `${item.actionName} bộ phụ kiện`;
    },
    onError(error) {
      toastHistoryError(
        error,
        this.config.forbiddenMessage,
        this.messages.LOAD_FAILED,
      );
    },
    showDetail(item) {
      this.$refs['history-detail'].show(item.id);
    },
  },
};
</script>
